import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Container, Spedizione, VoceContainer, VoceSpedizione} from "../_Models";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ApiRestService as ClientiApiRestService} from "../../Admin/_service/api-rest.service";
import {ApiRestService} from "../api-rest.service";
import {ContainerVociEditComponent} from "../container-voci-edit/container-voci-edit.component";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ToastrService} from "ngx-toastr";
import {ApiPathsService} from "../../api-paths.service";

@Component({
  selector: 'app-container-edit',
  templateUrl: './container-edit.component.html'
})
export class ContainerEditComponent implements OnInit {
  @Input() isModal: boolean = false;
  @Input() item: Container;
  @Output() Saved = new EventEmitter<boolean>();
  Spedizioni: Spedizione[] = [];
  @Input() spedizioniSelezionate: Spedizione[] = [];
  Fattura: string = '';
  DropdownSettings:IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'numero',
    allowSearchFilter: true,
  };
  dataFattura: string = '';
  Proforma: string = '';
  dataProforma: string = '';
  constructor(
    private ngbActiveModal: NgbActiveModal,
    private ngbModal: NgbModal,
    private clientiApiRest : ClientiApiRestService,
    private apiRestService : ApiRestService,
    private apiPaths: ApiPathsService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.refresh();
  }
  setFattura(){
    if(this.item.voci.every(x=> !x.fattura ) || confirm("Sei sicuro di voler sovrascrivere i valori?"))
      this.item.voci.forEach(voce=>{
        voce.fattura = this.Fattura;
        voce.dataFattura = this.dataFattura;
      });
    this.toastrService.warning('Premere su salva per apportare le modifiche.')
  }

  refresh(){
    if(this.item.id){
        this.apiRestService.PrimaNotaContainerGet(this.item).subscribe(data => {
          this.item = data;
        })
    }
    this.apiRestService.PrimaNotaSpedizioniList({page:0, size:10, stato: "TS", periodo: false}).subscribe(data=>{
      this.Spedizioni = data.data;
    })
  }
  save() {
    if(this.item.id)
      this.apiRestService.PrimaNotaContainerUpdate(this.item).subscribe(()=> {
        this.Saved.emit(true);
        this.close();
      })
    else
      this.apiRestService.PrimaNotaContainerAdd(this.item).subscribe(()=> {
        this.Saved.emit(true);
        this.close();
      })

  }
  close() {
    this.ngbActiveModal.dismiss();
  }
  EditVoce(item?: VoceContainer) {
    if (!item && this.spedizioniSelezionate) {
      let modale = this.ngbModal.open(ContainerVociEditComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<ContainerVociEditComponent>modale.componentInstance).isModal = true;
      (<ContainerVociEditComponent>modale.componentInstance).spedizione = this.spedizioniSelezionate[0];
      (<ContainerVociEditComponent>modale.componentInstance).AddClick.subscribe(voce => {
        if (!this.item?.voci?.find(x => x.voce_id == voce.voce_id)) {
          const sel = Object.assign({}, voce)
          sel.id = undefined;
          this.item?.voci?.push(sel);
          this.toastrService.success("Voce inserita correttamente");
        }
        else {
          const idx: number = this.item?.voci?.findIndex(x => x.voce_id == voce.voce_id)
          if (idx > -1) {
            this.item.voci[idx].quantita = this.item?.voci[idx]?.quantita + voce.quantita;
            if (this.item?.voci[idx]?.quantita > this.item?.voci[idx]?.disponibilita){
              this.toastrService.warning("La quantità inserita è maggiore della disponoibilità ("+voce.disponibilita.toString()+")");
              this.item.voci[idx].quantita = this.item.voci[idx].disponibilita
            }
          }
        }
      });
    }
    else if(!this.spedizioniSelezionate)
      this.toastrService.warning("Seleziona una spedizione")
    else if(item.modifica ){
      if (item.quantita <=  item.disponibilita)
        item.modifica = !item.modifica;
      else
        this.toastrService.warning("La quantità inserita è maggiore della disponoibilità ("+item?.disponibilita?.toString()+")");
    }else
      item.modifica = !item.modifica;
  }
  DeleteVoce(item: VoceSpedizione) {
    if(item.modifica) {
      item.modifica = !item.modifica;
      return;
    }
    const idx: number = this.item?.voci?.findIndex(x => x == item);
    if (idx > -1) {
      this.item?.voci?.splice(idx, 1);
    }
  }

  InviaAdhoc() {
    this.apiPaths.ClassicPost('/primanota/container/adhoc', {id: this.item.id}).subscribe(()=> {
      this.toastrService.success("Container Inviato correttamente ad AdHoc")
    })
  }

  setProforma() {
    if(this.item.voci.every(x=> !x.proforma ) || confirm("Sei sicuro di voler sovrascrivere i valori?"))
      this.item.voci.forEach(voce=>{
        voce.proforma = this.Proforma;
        voce.dataProforma = this.dataProforma;
      });
    this.toastrService.warning('Premere su salva per apportare le modifiche.')
  }
}
